<div class="form-control-container"
     *ngIf="control">
      <label *ngIf="control.label"
             [attr.for]="control.controlId" [innerText]="control.label">    
        <ng-content select="[label-extension]"></ng-content>
      </label>
      <div class="form-control-container-content">    
        <ng-content></ng-content>  
      </div>
  <validation-messages *ngIf="!control.hideValidationMessages && control.invalid"
                       [errors]="control.errors">
      </validation-messages></div>